import React from "react";
import { z } from "zod";
import { ArticleMediaCarousel } from "../../ArticleMediaCarousel";
import { transformToGroupedMediaPromos, MediaPromosListBladeSchema, } from "../../../schemas/blades/MediaPromosList";
import styled from "styled-components";
export const ArticleMediaGalleryContractSchema = MediaPromosListBladeSchema.extend({
    type: z.literal("articleMediaGallery"),
});
const _ArticleMediaGallery = (props) => {
    const { items, ...bladeProps } = props;
    const transformedGroups = transformToGroupedMediaPromos(items);
    return React.createElement(ArticleMediaCarousel, { ...bladeProps, groups: transformedGroups });
};
export const ArticleMediaGallery = styled(_ArticleMediaGallery) ``;
//# sourceMappingURL=ArticleMediaGallery.js.map